// extracted by mini-css-extract-plugin
module.exports = {"richText":"RichtextWithBg_richText__0O_j3","maxCharacterCount":"RichtextWithBg_maxCharacterCount__xgkhE"};